module.exports = __webpack_public_path__ + "img/icon-0.5088c804.svg";